import React from 'react';
import PropTypes from 'prop-types';
import '../../polyfills/polyfill-allSettled';
import EventInfoCard from '../events-list/EventInfoCard';
import { Body } from '../styled components/Typography';

const EventsSearchResults = (props) => {
  const { events, searchValue } = props;
  return (
    <>
      {events.length ? (
        <div tw="space-y-8 mb-16">
          {events.map((e) => (
            <EventInfoCard
              eventInfo={e}
              {...props}
              isFeatureActive={() => false}
              key={`eventinfo-${e.id}`}
              showDate
              showGroup
            />
          ))}
        </div>
      ) : (
        <div tw="text-center mt-8">
          <Body $color="gray dark">
            {i18n`None of your events match with event name "${searchValue}"`}
          </Body>
        </div>
      )}
    </>
  );
};

EventsSearchResults.propTypes = {
  events: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchValue: PropTypes.string.isRequired
};

function ForwardRef(props, ref) {
  return <EventsSearchResults {...props} forwardedRef={ref} />;
}

export default React.forwardRef(ForwardRef);
